/**
 * In the layout: when the server refuses a photo or AI call because the plan isn't running yet (402 photo_plan; api.ts PHOTO_PLAN_EVENT;
 * owner, 2026-10-12), "Start your 25 free days to use photos" opens (components/PlanGate.tsx PhotoPlanSheet, loaded on first use).
 */
import { Suspense, useEffect, useState } from "react";
import { PHOTO_PLAN_EVENT } from "../api.ts";
import { lazyNamed } from "../lib/lazy.ts";

const PhotoPlanSheet = lazyNamed(() => import("./PlanGate.tsx"), "PhotoPlanSheet");

export function PhotoPlanHost() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setOpen(true);
    try { window.addEventListener(PHOTO_PLAN_EVENT, on); } catch { return; }
    return () => window.removeEventListener(PHOTO_PLAN_EVENT, on);
  }, []);
  return open ? <Suspense fallback={null}><PhotoPlanSheet onClose={() => setOpen(false)} /></Suspense> : null;
}
